import PropTypes from "prop-types";
import React from "react";

const money = (n) => (n >= 1000 ? `$${(n / 1000).toFixed(1)}k` : `$${Math.round(n)}`);

const EstRevenueCard = ({ hold, onConfirm }) => {
  const r = hold.estRevenue;
  return (
    <div className="d2-card hd-detail-card hd-rev-card">
      <div className="d2-card-header"><h3 className="d2-card-title">Est. revenue if confirmed</h3></div>
      {r ? (
        <>
          <div className="hd-rev-total">{`${money(r.low)}–${money(r.high)}`}</div>
          <div className="hd-rev-basis">{`Tickets + bar, at ${hold.projTickets.low}–${hold.projTickets.high} attendance`}</div>
          <div className="hd-rev-lines">
            <div className="hd-rev-line"><span>{`Ticket sales · avg $${r.ticketPrice}`}</span><strong>{`${money(r.tickets.low)}–${money(r.tickets.high)}`}</strong></div>
            {r.bar && <div className="hd-rev-line"><span>{`Bar · $${r.barPerHead}/head`}</span><strong>{`${money(r.bar.low)}–${money(r.bar.high)}`}</strong></div>}
          </div>
        </>
      ) : (
        <div className="hd-empty"><div className="hd-empty-title">Not enough history</div>
          <div className="hd-empty-sub">Confirm a few comparable shows to unlock revenue estimates.</div></div>
      )}
      <div className="hd-rev-actions">
        <button type="button" className="hd-btn hd-btn-primary" onClick={onConfirm}>Confirm this date</button>
      </div>
    </div>
  );
};

EstRevenueCard.propTypes = {
  hold: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default EstRevenueCard;
